// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3IQXm","naviBarBox":"index-naviBarBox-32Xmp","pageItem":"index-pageItem-TRCSQ","footer":"index-footer-2wEIW","isActive":"index-isActive-1CSNQ"};